import { useDispatch } from "react-redux";
import { useCart, useCartId, useCreateCart } from "@kega/sps-core";
import { updateCart } from "@kega/sps-core/src/reducers/cart/actions";

const useCartMerge = () => {
    const dispatch = useDispatch();
    const { fetchCart } = useCart();
    const { createCart } = useCreateCart();
    const getCartId = useCartId();

    const syncFullCart = async () => {
        const cart = await fetchCart("current", { fields: "FULL" });

        if (cart) {
            dispatch(updateCart(cart));
        }

        return cart;
    };

    const mergeCartAfterLogin = async () => {
        const oldCartId = getCartId();
        const storedGuestCartId = localStorage.getItem("guestCartIdForMerge");
        const cartIdToMerge = oldCartId || storedGuestCartId;

        if (cartIdToMerge) {
            const currentCart = await fetchCart("current");

            try {
                const mergeResult = await createCart({
                    oldCartId: cartIdToMerge,
                    mergeCartId: currentCart?.guid,
                    userId: "current",
                });

                if (mergeResult) {
                    dispatch(updateCart(mergeResult));
                }
            } catch (mergeError) {
                try {
                    const fallbackResult = await createCart({
                        oldCartId: cartIdToMerge,
                        userId: "current",
                    });

                    if (fallbackResult) {
                        dispatch(updateCart(fallbackResult));
                    }
                } catch (fallbackError) {
                    console.error(
                        "Fallback cart creation failed:",
                        fallbackError
                    );
                }
            }

            if (storedGuestCartId) {
                localStorage.removeItem("guestCartIdForMerge");
            }

            return syncFullCart();
        }

        try {
            const currentCart = await fetchCart("current");

            if (!currentCart?.cartId) {
                const newCart = await createCart({ userId: "current" });

                if (newCart) {
                    dispatch(updateCart(newCart));
                }
            }
        } catch (fetchError) {
            console.error("Failed to fetch current cart:", fetchError);
        }

        return syncFullCart();
    };

    return {
        mergeCartAfterLogin,
    };
};

export default useCartMerge;
